import { render, staticRenderFns } from "./profile.vue?vue&type=template&id=522ce2f1&scoped=true&"
import script from "./profile.vue?vue&type=script&lang=ts&"
export * from "./profile.vue?vue&type=script&lang=ts&"
import style0 from "./profile.vue?vue&type=style&index=0&id=522ce2f1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522ce2f1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ProfileCard: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/profile/ProfileCard.vue').default,EmptyContentAlternative: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/EmptyContentAlternative.vue').default,CommunityCardGrid: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/community/CommunityCardGrid.vue').default,CommonInfiniteLoader: require('C:/Users/alinu/Workspace/Machinations-website/wp-nuxt/components/common/CommonInfiniteLoader.vue').default})
